import * as React from "react";
import { ThunkDispatch } from "redux-thunk";
import { connect } from "react-redux";

import { authorize } from "reauthorize";

import { ConfirmedButton } from "@teamprevent/common/confirmedButton/ConfirmedButton";

import { AppState, CustomerEditModel } from "../../model";
import { basePathSelector, customerSelector } from "../../selectors";
import { deactivateCustomer } from "../../actions";
import { ADMIN_ROLES } from "../../../../auth/model";

interface MergedProps {
    deactivate: () => void;
    customerName: string;
}

class DeactivateButton extends React.Component<MergedProps> {
    constructor(props: MergedProps) {
        super(props);
        this.deactivate = this.deactivate.bind(this);
    }

    public render() {
        return (
            <ConfirmedButton
                icon="power"
                className="negative ui button"
                content="Deactivate"
                floated="left"
                onClick={this.deactivate}
                // eslint-disable-next-line max-len
                promptText="Are you sure you want to make this customer inactive? this will stop them being used within the system and cancel all inflight cases.
            Type 'DEACTIVATE' and click confirm to make the customer inactive."
                headingText="Deactivate Customer"
                typeToConfirmText="DEACTIVATE"
            />);
    }

    private deactivate() {
        this.props.deactivate();
    }
}

interface StateProps {
    id: any;
    basePath: string;
    model: CustomerEditModel;
}

interface DispatchProps {
    dispatchDeactivate: (id: any, basePath: string, model: CustomerEditModel) => void;
}

function mapStateToProps(state: AppState): StateProps {
    return {
        id: state.router.params.customerId,
        basePath: basePathSelector(state),
        model: customerSelector(state) as CustomerEditModel,
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<AppState, undefined, any>): DispatchProps {
    return {
        dispatchDeactivate: (id) => dispatch<any>(deactivateCustomer(id))
    };
}

function mergeProps(propsFromState: StateProps, propsFromDispatch: DispatchProps): MergedProps {
    return {
        deactivate: () => propsFromDispatch.dispatchDeactivate(propsFromState.id, propsFromState.basePath, propsFromState.model),
        customerName: propsFromState.model.name
    };
}

export default authorize([ADMIN_ROLES.SENIOR_ADMINISTRATOR.name, ADMIN_ROLES.SYSTEM_ADMIN.name])(
    connect(mapStateToProps, mapDispatchToProps, mergeProps)(DeactivateButton));
